import React, { useState, useRef } from 'react';
import { PromptGenerator } from './components/PromptGenerator';
import { GrokInterface } from './components/GrokInterface';
export function App() {
  const [promptForGrok, setPromptForGrok] = useState('');
  const grokRef = useRef(null);
  const sendToGrok = prompt => {
    setPromptForGrok(prompt);
    // Scroll to Grok section
    if (grokRef.current) {
      grokRef.current.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <div className="min-h-screen bg-gray-50 w-full" data-id="element-0">
      <PromptGenerator sendToGrok={sendToGrok} data-id="element-1" />
      <div className="py-6 sm:py-8 bg-gradient-to-b from-indigo-50 to-blue-50" ref={grokRef} data-id="element-2">
        <GrokInterface initialPrompt={promptForGrok} data-id="element-3" />
      </div>
    </div>;
}